import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const MentionSearchParamsSchema = BasePaginateParamsSchema.extend({
  isUnreadOnly: z.coerce.boolean().optional(),
  entityType: z.string().optional(),
  fromDate: z.coerce.date().optional(),
  toDate: z.coerce.date().optional(),
})

export const MentionListItemSchema = z.object({
  id: z.string(),
  messageId: z.string().nullable(),
  conversationThreadId: z.string().nullable(),
  entityType: z.string(),
  entityId: z.string(),
  url: z.string(),
  messagePreview: z.string(),
  mentionedByUserId: z.number(),
  mentionedAt: z.coerce.date(),
  isRead: z.boolean(),
  readAt: z.coerce.date().nullable(),
})

export const MentionSearchResultSchema = z
  .object({
    data: z.array(MentionListItemSchema),
  })
  .merge(BasePaginateResultSchema)

export type MentionSearchParams = z.infer<typeof MentionSearchParamsSchema>
export type MentionListItem = z.infer<typeof MentionListItemSchema>
export type MentionSearchResult = z.infer<typeof MentionSearchResultSchema>
